import { CreationToolProps } from "@kaltura/mediaspace-shared-search-and-select";
import { UploadMediaContainer, UploadProps } from "@kaltura/mediaspace-shared-upload";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { useState } from "react";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";

export interface UploadCreationToolProps extends CreationToolProps, UploadProps {}

/**
 * Upload creation tool for the quiz creation page - connect the upload component with creation tool flow
 */
export const UploadCreationTool = (props: UploadCreationToolProps) => {
    const [finishedUploading, setFinishedUploading] = useState(false);

    const handleSubmit = (entry: KalturaMediaEntry) => {
        // Proceed to selecting the entry for quiz only if the upload has finished
        if (finishedUploading) {
            props.onSubmit?.(entry);
        }
    };

    return (
        <UploadMediaContainer
            {...props}
            showBackButton={false}
            centerTitle={false}
            secondaryTitleHeader={true}
            publishEnabled={false}
            singleUpload={true}
            showEditFormButtons={true}
            showCancelButton={false}
            allowSaveUntouched={true}
            onEntryFinishedUploading={() => setFinishedUploading(true)}
            saveButtonLabel={finishedUploading ? translate("Save & Select") : translate("Save")}
            onSubmit={handleSubmit}
        />
    );
};
